import React from 'react'
import { Form, Input, Checkbox } from 'antd'
import { CUSTOM_SCAN_FIELD, MOBILE_VIEWPORT, SCAN_PARAMETERS_FLAG_FIELD } from '../constants'
import { TooltipLabel } from 'components/TooltipLabel';

const pagesTooltip = "Enter list of URLs, each on it’s own line. For parameterized scans use $BASE_ADDRESS for all the URLs. You can also use $BASE_ADDRESS/folder/page";
const enableParameterTooltip = "Check this option to allow insert parameters prior each scan to manipulate the outcome. This option will only be enabled if there are parameters to use.";
const mobileViewTooltip = "Check this option to do a scan for a mobile device.";

const CustomScan = ({ getFieldDecorator, simple=false }) => {
	const { TextArea } = Input;
	return (
		<>
		<Form.Item>
			<TooltipLabel required htmlFor="pages" value="PAGES" tooltip={{hidden: simple, text: pagesTooltip}} />
			{getFieldDecorator(CUSTOM_SCAN_FIELD, {
				rules: [
					{
						required: true,
						message: 'required'
					}
				]
			})(<TextArea id="pages" rows={10} placeholder="http://www.yourwebsite.com/page1.html&#13;&#10;http://www.yourwebsite.com/page2.html&#13;&#10;http://www.yourwebsite.com/page3.html" />)}
		</Form.Item>
		{!simple && <><Form.Item name="parameters">
            {getFieldDecorator(SCAN_PARAMETERS_FLAG_FIELD, {
                initialValue: false,
                valuePropName: 'checked'
            })( 
              <Checkbox id="enableParameters">
                <TooltipLabel htmlFor="enableParameters" value="ENABLE PARAMETERS " 
                  tooltip={{text: enableParameterTooltip}} 
                />  
              </Checkbox>
            )}
          </Form.Item>
		  <Form.Item>
          {getFieldDecorator(MOBILE_VIEWPORT, {
            initialValue: false,
            valuePropName: 'checked'
          })(<Checkbox><TooltipLabel htmlFor={MOBILE_VIEWPORT} value="MOBILE VIEWPORT"
            tooltip={{text: mobileViewTooltip}}
            /> </Checkbox>)}
            </Form.Item>
		  </>
		  }
		</>
	)
}
export default CustomScan
